import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { paths } from 'src/config/paths'
import { ResponsivePopup } from 'src/shared/components/ui/popups/responsive-popup'
import { DirectionArrow } from 'src/shared/features/users/assets/direction-arrow'

import ForwardToRealEstateAgent from '../../../users/components/marketplace/assets/fwd-to-re.png'

import ConsumerLoginForm from './login-form'
import ConsumerSignupForm from './signup-form'

interface ConsumerAuthDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  initialView?: 'login' | 'signup'
  signupTitle?: string
}

const ConsumerAuthDialog = ({ open, onOpenChange, initialView = 'login', signupTitle }: ConsumerAuthDialogProps) => {
  const [view, setView] = useState<'login' | 'signup'>(initialView)
  const navigate = useNavigate()

  const handleSuccess = () => {
    onOpenChange(false)
  }

  const onSwitchToProfessional = () => {
    onOpenChange(false)
    navigate(paths.auth.login.getHref())
  }

  useEffect(() => {
    setView(initialView)
  }, [initialView])

  const switchToLogin = () => setView('login')
  const switchToSignup = () => setView('signup')

  return (
    <ResponsivePopup
      open={open}
      onOpenChange={onOpenChange}
      trigger={<div />}
      mobileRoute={paths.consumer.auth.signup.getHref()}
      hideHeader
      hideCloseButton
      removePadding
      className="z-[9999] p-0 sm:max-w-[440px]"
      floatingFooter={
        <div className="flex h-[100px] items-center justify-start gap-5 rounded-lg border bg-[#f7f1eb] p-3">
          <img src={ForwardToRealEstateAgent} alt="Forward to Real Estate Agent" className="h-[75px] w-[100px]" />
          <p className="text-[22px] font-bold leading-tight text-primary">I&apos;m a real estate professional</p>
          <button
            type="button"
            onClick={onSwitchToProfessional}
            className="flex size-[40px] min-w-[40px] items-center justify-center rounded-[40px] bg-primary text-sm text-white"
          >
            <DirectionArrow size={20} />
          </button>
        </div>
      }
    >
      <div className="p-8">
        {view === 'login' ? (
          <ConsumerLoginForm onSuccess={handleSuccess} />
        ) : (
          <ConsumerSignupForm onSuccess={handleSuccess} title={signupTitle} />
        )}
      </div>

      {view === 'login' ? (
        <div className="flex h-[70px] items-center justify-between gap-2 border-t bg-[#f7f1eb] p-5">
          <p className="text-base font-semibold text-primary">I don&apos;t have an account</p>
          <button
            type="button"
            onClick={switchToSignup}
            className="text-[15px] font-semibold text-primary hover:underline"
          >
            Sign up <span className="ml-1 text-lg">→</span>
          </button>
        </div>
      ) : (
        <div className="flex h-[70px] items-center justify-between gap-2 border-t bg-[#f7f1eb] p-5">
          <p className="text-base font-semibold text-primary">Already have an account?</p>
          <button
            type="button"
            onClick={switchToLogin}
            className="text-[15px] font-semibold text-primary hover:underline"
          >
            Log in <span className="ml-1 text-lg">→</span>
          </button>
        </div>
      )}
    </ResponsivePopup>
  )
}

export default ConsumerAuthDialog
